import React from 'react';
import PropTypes from 'prop-types';
import css from './Notification.css';
import Icon from 'SF/MaterialIcon';
import commonWidgetCSS from './CommonWidget.css';
import DrawerOpenButton from './DrawerOpenButton';
import InterventionDetails from './InterventionDetails';
import {RequestHelp} from 'utils/types';

const notificationConstants = (type, isCritical) => {
  if (type === 'REFERRAL') return {'display': 'REFERRAL', 'icon': 'exit_to_app'};
  if (type === 'TO_DO') return {'display': 'TO DO', 'icon': 'check_box'};
  if (type === 'FLAG') return {'display': isCritical ? 'CRITICAL FLAG' : 'FLAG', 'icon': 'flag'};
};

/**
 * A component representing a Notification
 *
 * This could be a referral, to do, or flag.
 *
 * @param {object} props - props for the component (defined with PropTypes below)
 * @returns {React.Component} a React component containing a list of info items about the notification.
 */
const Notification = (props) => {
  const getClosureDetails = () => {
    if (props.type !== 'TO_DO')
      return null
    if (props.closureReviewRequired && props.requestedResolutionDate)
      return <div className={css['pending-review']}>Pending Review</div>
    if ((props.closureReviewRequired || props.studentCloseable) && !props.requestedResolutionDate)
      return <DrawerOpenButton successToastMessage={props.successToastMessage} buttonText='Mark As Complete' {...props} />
  };

  return (
    <div className={`${css.container} ${notificationConstants(props.type, props.critical).display === 'CRITICAL FLAG' ? css['critical-flag-border'] : '' } ${commonWidgetCSS.container}`} data-role={props.type}>
      <div className={css['notification-info']}>
        <div className={css.icon}><Icon icon={notificationConstants(props.type, props.critical).icon} /></div>
        <main>
          <header>
            <div className={`${notificationConstants(props.type, props.critical).display === 'CRITICAL FLAG' ? css['critical-flag-label'] : '' }`}>
              <span>{notificationConstants(props.type, props.critical).display}</span>
            </div>
            <h3 className={css.name}>{props.name}</h3>
          </header>
          <div className={css.content} data-role='content'>
            <InterventionDetails {...props} />
          </div>
        </main>
      </div>
      {getClosureDetails()}
    </div>
  )
};

Notification.propTypes = {
  assignee: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  dueDate: PropTypes.string,
  name: PropTypes.string.isRequired,
  plan: PropTypes.object,
  raisedDate: PropTypes.string.isRequired,
  successToastMessage: PropTypes.func.isRequired,
  raiseNotes: PropTypes.string,
  raiser: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  section: PropTypes.shape({
    cmsCourseId: PropTypes.string,
    name: PropTypes.string,
  }),
  studentId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  critical: PropTypes.bool.isRequired,
  studentCloseable: PropTypes.bool.isRequired,
  closureReviewRequired: PropTypes.bool.isRequired,
  requestedResolutionDate: PropTypes.string,
  requestHelp: RequestHelp.isRequired
};

export default Notification;

